export { ModalAnimatedContent } from './ModalAnimatedContent';
